import React, { useState, useEffect, useMemo } from "react"
import { useSelector, useDispatch } from "react-redux"
import { useNavigate } from "react-router"
import {
  MapContainer,
  TileLayer,
  Marker,
  Popup,
  Polyline,
  useMap,
} from "react-leaflet"
import "leaflet/dist/leaflet.css"
import L from "leaflet"
import {
  setSelectedStation,
  setOrderDetailsClicked,
  clearStationData,
  getStationsFromSession,
} from "../../features/stations/stationsSlice.js"
import {
  getLastDriverLocation,
  getDriverLocationsByRoute,
} from "./stationsManagerPageSlice.js"
import { setSelectedRoute } from "../../features/routes/routesSlice.js"
import { Header } from "../../features/common/header/header"
import { SingleStationManager } from "./singleStationManager/singleStationManager"
import { setShowOrders } from "../../features/orders/ordersSlice.js"
import { setMapView } from "../../features/driverMap/driverMapSlice.js"
import { Orders } from "../../features/orders/orders"
import { ButtonWhite } from "../../features/common/buttonWhite/buttonWhite"
import { getFormatedDate } from "../../utils/formatDate"
import iconCar from "../../assets/images/iconCar.png"
import "./stationsManagerPage.scss"

export function StationsManagerPage() {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const { stationListFromSession } = useSelector((state) => state.stations)
  const { token } = useSelector((state) => state.loginOTP)
  const { showOrders } = useSelector((state) => state.orders)
  const { showDriverMap } = useSelector((state) => state.driverMap)
  const { currentLanguage } = useSelector((state) => state.main)
  const { selectedDriver } = useSelector((state) => state.driversOnRoute)
  const { driverLocation, driverLocationsList } = useSelector(
    (state) => state.stationsManager
  )
  const [searchTerm, setSearchTerm] = useState(null)
  const [sortedStationsList, setSortedStationsList] = useState(null)
  const [filteredStationsList, setFilteredStationsList] = useState(null)
  const position = [32.0853, 34.7818]
  useEffect(() => {
    //dispatch(clearStationData())

    dispatch(
      getStationsFromSession({
        token: token,
        routeId: selectedDriver.routeId,
        driverId: selectedDriver.driverId,
      })
    )
    // dispatch(
    //   getLastDriverLocation({
    //     token: token,
    //     routeId: selectedDriver.routeId,
    //     driverId: selectedDriver.driverId,
    //   })
    // )
    dispatch(
      getDriverLocationsByRoute({
        token: token,
        routeId: selectedDriver.routeId,
        driverId: selectedDriver.driverId,
        sessionId: selectedDriver.sessionId,
      })
    )
  }, [])

  useEffect(() => {
    if (stationListFromSession?.length > 0) {
      const sortedStations = customSortStations()
      setSortedStationsList(sortedStations)
    } else {
      setSortedStationsList(null)
    }
  }, [stationListFromSession])

  useEffect(() => {
    if (stationListFromSession?.length > 0 && searchTerm) {
      const filteredStations = sortedStationsList.filter(
        (station) =>
          String(station.stationNumber).includes(searchTerm) ||
          station.address?.includes(searchTerm) ||
          station.address_en?.includes(searchTerm) ||
          station.name?.includes(searchTerm) ||
          station.name_en?.includes(searchTerm)
      )
      setFilteredStationsList(filteredStations)
    } else {
      setFilteredStationsList(sortedStationsList)
    }
  }, [searchTerm, sortedStationsList])

  const carIcon = new L.Icon({
    iconUrl: iconCar,
    iconSize: [35, 45],
  })

  const handleShowOrders = (selectedStation) => {
    dispatch(setSelectedStation(selectedStation))
    dispatch(
      setSelectedRoute({
        routeIndex: null,
        routeId: selectedDriver.routeId,
        routeName: selectedDriver.routeName,
      })
    )
    dispatch(setOrderDetailsClicked(true))
    dispatch(setShowOrders(true))
  }

  const setStationView = (coordinates) => {
    dispatch(setMapView(coordinates))
  }

  const customSortStations = () => {
    if (stationListFromSession?.length > 0) {
      const stationsCopy = [...stationListFromSession]

      return stationsCopy.sort((a, b) => {
        const aCondition = a.ordersTotal === 0 && a.routePlanningStatus === 2
        const bCondition = b.ordersTotal === 0 && b.routePlanningStatus === 2

        if (aCondition && !bCondition) return 1
        if (!aCondition && bCondition) return -1
        return 0
      })
    } else {
      return null
    }
  }

  const RecenterMap = ({ position }) => {
    const map = useMap()
    useEffect(() => {
      if (position) {
        map.setView(position, map.getZoom())
      }
    }, [position, map])
    return null
  }

  const renderStations = () => {
    if (!filteredStationsList) {
      return <div className="station-empty">אין רשומות</div>
    }
    return filteredStationsList?.map((station) => {
      return (
        <SingleStationManager
          stationData={station}
          key={station.id}
          currentLanguage={currentLanguage}
          showOrders={(selectedStation) => handleShowOrders(selectedStation)}
          setStationView={(coordinates) => setStationView(coordinates)}
          showMapIcons={showDriverMap}
        />
      )
    })
  }

  const sortedLocations = useMemo(() => {
    if (!driverLocationsList || driverLocationsList.length <= 1) return []
    return [...driverLocationsList].sort(
      (a, b) => new Date(a.createdDate) - new Date(b.createdDate)
    )
  }, [driverLocationsList])

  const polylinePositions = sortedLocations.map((loc) => [
    loc.latitude,
    loc.longitude,
  ])

  const startIcon = new L.DivIcon({
    html: "🟢",
    className: "",
    iconSize: [28, 28],
    iconAnchor: [14, 14],
  })

  const pointIcon = new L.DivIcon({
    html: "⚪",
    className: "",
    iconSize: [20, 20],
    iconAnchor: [10, 10],
  })

  const endIcon = new L.DivIcon({
    html: "🔴",
    className: "",
    iconSize: [28, 28],
    iconAnchor: [14, 14],
  })

  return (
    <div>
      <Header />
      <div className="stationsManagerPage">
        <div className="stations-container">
          <div className="header">
            <ButtonWhite text="חזור" clickHandler={() => navigate(-1)} />
            <div className="search">
              <input
                type="text"
                placeholder="חפש תחנה:"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
            </div>
          </div>

          <div className="line"></div>
          <div className="stations-list">{renderStations()}</div>
        </div>
        <div className="location">
          <MapContainer
            center={polylinePositions[0] ?? [32.0092605, 34.7638723]}
            zoom={14}
            zoomControl={false}
            attributionControl={false}
            style={{ height: "100%", width: "100%" }}
          >
            <TileLayer
              attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
              url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
            />

            {polylinePositions.length > 1 && (
              <Polyline positions={polylinePositions} />
            )}

            {sortedLocations.map((location, index) => {
              let icon = pointIcon

              if (index === 0) {
                icon = startIcon
              } else if (index === sortedLocations.length - 1) {
                icon = endIcon
              }

              return (
                <Marker
                  key={index}
                  position={[location.latitude, location.longitude]}
                  icon={icon}
                >
                  <Popup>{getFormatedDate(location.createdDate)}</Popup>
                </Marker>
              )
            })}
          </MapContainer>
        </div>
        {showOrders ? <Orders /> : null}
      </div>
    </div>
  )
}
